import { useEffect, useRef, useState } from "react";
import { Target, Layers, Users, RefreshCw, Compass, ArrowUpRight } from "lucide-react";
import "./globalCapDetailBenefits.css";

const icons = [Target, Layers, Users, RefreshCw, Compass];

export default function GlobalCapDetailBenefits({ data }) {
  const items = data?.items ?? [];
  const [visible, setVisible] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const node = ref.current;
    if (!node) return undefined;

    if (typeof IntersectionObserver === "undefined") {
      setVisible(true);
      return undefined;
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.12 }
    );
    observer.observe(node);

    return () => observer.disconnect();
  }, []);

  if (!items.length) return null;

  return (
    <section
      ref={ref}
      className={`gcdb ${visible ? "gcdb--visible" : ""}`}
    >
      <div className="gcdb__container">
        <header className="gcdb__header">
          <div className="gcdb__heading">
            {data.eyebrow && (
              <span className="gcdb__eyebrow">
                <span className="gcdb__eyebrow-dot" aria-hidden="true" />
                {data.eyebrow}
              </span>
            )}
            <h2 className="gcdb__title">{data.title}</h2>
          </div>

          {data.intro && <p className="gcdb__intro">{data.intro}</p>}
        </header>

        <ul className={`gcdb__grid gcdb__grid--n${items.length}`}>
          {items.map((item, index) => {
            const Icon = icons[index % icons.length];

            return (
              <li
                key={item.title}
                className="gcdb__cell"
                style={{ "--i": index }}
              >
                <div className="gcdb__top">
                  <span className="gcdb__icon" aria-hidden="true">
                    <Icon size={22} strokeWidth={1.7} />
                  </span>
                  <span className="gcdb__arrow" aria-hidden="true">
                    <ArrowUpRight size={18} strokeWidth={1.8} />
                  </span>
                </div>

                <div className="gcdb__body">
                  <h3 className="gcdb__cell-title">{item.title}</h3>
                  <span className="gcdb__rule" aria-hidden="true" />
                  <p className="gcdb__cell-text">{item.description}</p>
                </div>
              </li>
            );
          })}
        </ul>
      </div>
    </section>
  );
}
